module.exports = __webpack_public_path__ + "img/Nerve-active.30df8a3e.png";